export default __webpack_public_path__ + "static/media/1845.5137380c.png";